import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import { DriverDocumentsPage } from 'routes/paths';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import { useQueryParams } from 'hooks/useSearchParams';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';

export interface EndOfTheFlowProps {
  className?: string;
}

function OneMoreThing(props: EndOfTheFlowProps) {
  const queryParams = useQueryParams();

  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate(
      `${DriverDocumentsPage}?from=${DocumentTypeEnum.DRIVER_CHECKLIST}`
    );
  };
  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.iconCircle}>
        <svg
          width="38"
          height="46"
          viewBox="0 0 38 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38 10.2093V40.8056C38 42.1833 37.4609 43.5042 36.5016 44.4782C35.5422 45.4521 34.2413 45.9996 32.8845 45.9996H29.0627L29.0629 46H21.1589C21.1592 45.9999 21.1595 45.9998 21.1597 45.9996C22.9518 45.1938 24.2941 43.5448 24.6982 41.5482C24.6982 41.5481 24.6983 41.548 24.6983 41.5478H32.8845C33.0787 41.5478 33.2642 41.4697 33.4013 41.3305C33.5384 41.1913 33.6154 41.0029 33.6154 40.8057V13.3546H24.8464V4.45164H5.11574C4.71202 4.45164 4.38477 4.78389 4.38477 5.19378V40.8061C4.38477 41.216 4.71202 41.5482 5.11574 41.5482H12.6419C13.0461 43.5451 14.3887 45.1943 16.1812 46H5.11574C3.75874 46 2.45793 45.4525 1.49859 44.4785C0.539305 43.5045 0 42.1837 0 40.8061V5.19386C0 3.81613 0.539253 2.49546 1.49859 1.52147C2.45798 0.547539 3.75887 0 5.11574 0H27.9443L38 10.2093Z"
            fill="#FF9900"
          />
          <path
            d="M16.4588 42.1405C15.8723 41.5162 15.5801 40.7492 15.5801 39.8634C15.5801 38.9557 15.8701 38.1792 16.4617 37.5639C17.0707 36.9301 17.866 36.6235 18.8101 36.6235C19.7632 36.6235 20.5607 36.9286 21.1599 37.5654C21.7506 38.1805 22.0401 38.9564 22.0401 39.8634C22.0401 40.7492 21.7479 41.5162 21.1614 42.1405C20.562 42.7785 19.764 43.0841 18.8101 43.0841C17.866 43.0841 17.0707 42.7774 16.4617 42.1436L16.4588 42.1405Z"
            fill="#FF9900"
          />
          <path
            d="M21.0237 15.7986V31.4433C21.0237 32.7328 19.9784 33.7781 18.6889 33.7781C17.3995 33.7781 16.3542 32.7328 16.3542 31.4433V15.7986C16.3542 14.5092 17.3995 13.4639 18.6889 13.4639C19.9784 13.4639 21.0237 14.5092 21.0237 15.7986Z"
            fill="#FF9900"
          />
        </svg>
      </div>
      <h3>One More Thing!</h3>
      <p>
        Make sure to update your medical card with your State Drivers Licensing
        Agency.{' '}
      </p>
      <div className={clsx(styles.link, styles.learnHowHereLink)}>
        <Link
          target="_blank"
          to={
            'https://www.fmcsa.dot.gov/registration/commercial-drivers-license/state-state-med-cert-submission-update'
          }
        >
          Learn how here.
        </Link>
      </div>
      {queryParams.showNext && (
        <div className={styles.link}>
          <ButtonWithArrowIcon
            type="button"
            className={styles.confirmButton}
            onClick={handleNextClick}
          >
            Next
          </ButtonWithArrowIcon>
        </div>
      )}
      {!queryParams.showNext && (
        <div className={styles.link}>
          <Link to={`${DriverDocumentsPage}`}>Upload Another Document</Link>
        </div>
      )}
    </div>
  );
}

export default OneMoreThing;
